import { LIVE, type AccountStatus, type StoreEnvironment } from '../../../api/accounts'

const LABEL: Record<AccountStatus, string> = {
	active: 'Active',
	grace: 'Grace period',
	granted: 'Granted',
	expired: 'Expired',
	revoked: 'Refunded',
	suspended: 'Suspended',
	none: 'No access',
}

/** An account's effective access, colored live / lapsed / suspended. */
export function StatusBadge({ status }: { status: AccountStatus }) {
	const tone = status === 'suspended' ? 'danger' : LIVE.includes(status) ? 'live' : 'off'
	return <span className={`badge badge-${tone}`}>{LABEL[status]}</span>
}

/** Production, or the test environment a subscription came from (never counted in stats). */
export function EnvironmentBadge({ environment }: { environment: StoreEnvironment | null }) {
	if (!environment) return null
	return <span className={`badge ${environment === 'Production' ? 'badge-prod' : 'badge-test'}`}>{environment}</span>
}
